import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../config";
import { createScheduledInvoiceItems, deleteScheduledInvoiceItems } from "./useScheduledInvoiceItems";

type ScheduledInvoiceItem = {
    id?: number;
    service: number | { id: number; name: string };
    quantity: number;
    price: number;
};

type UpdateInvoiceScheduleInput = {
    id: number;
    scheduled_date?: string;
    status?: "scheduled" | "created";
    items?: Array<ScheduledInvoiceItem>;
};

const updateInvoiceSchedule = async (input: UpdateInvoiceScheduleInput) => {
    const { id, items, ...data } = input;

    const response = await api({
        method: "PATCH",
        url: `/items/scheduled_invoices/${id}`,
        data: data,
    });

    if (items) {
        await deleteScheduledInvoiceItems(id);
        if (items.length > 0) {
            await createScheduledInvoiceItems(id, items);
        }
    }

    return response.data.data;
};

export const useUpdateInvoiceSchedule = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (input: UpdateInvoiceScheduleInput) => updateInvoiceSchedule(input),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["scheduled-invoices"] });
        },
    });
};

